"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.peopleTableSlice = peopleTableSlice;
const peopleTableInitialState = {
    peopleTable: {
        currentNameSearchValue: '',
        pager: { numPages: 0, pageId: 1 },
    },
};
function peopleTableSlice(set) {
    return {
        ...peopleTableInitialState,
        setCurrentNameSearchValue(currentNameSearchValue) {
            set((state) => {
                state.peopleTable.currentNameSearchValue = currentNameSearchValue;
                return state;
            }, false, '[setCurrentNameSearchValue]');
        },
        setPeopleTablePagerPageId(pageId) {
            set((state) => {
                state.peopleTable.pager.pageId = pageId;
                return state;
            }, false, '[setPeopleTablePagerPageId]');
        },
        setPeopleTablePagerNumPages(numPages) {
            set((state) => {
                state.peopleTable.pager.numPages = numPages;
                return state;
            }, false, '[setPeopleTablePager]');
        },
    };
}
